"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributionPaymentsQuery = exports.distributionQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
/**
 * @hidden
 *
 * Get distribution details for a CAId
 */
function distributionQuery(variables) {
    const query = (0, graphql_tag_1.default) `
    query DistributionQuery($assetId: String!, $localId: Int!) {
      distributions(filter: { assetId: { equalTo: $assetId }, localId: { equalTo: $localId } }) {
        nodes {
          taxes
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.distributionQuery = distributionQuery;
/**
 * @hidden
 *
 * Get history of claims for a distribution
 */
function distributionPaymentsQuery(filters, size, start) {
    const query = (0, graphql_tag_1.default) `
    query DistributionPaymentQuery($distributionId: String!, $size: Int, $start: Int) {
      distributionPayments(
        filter: { distributionId: { equalTo: $distributionId } }
        first: $size
        offset: $start
      ) {
        totalCount
        nodes {
          eventId
          targetId
          datetime
          amount
          tax
          createdBlock {
            blockId
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables: Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start)),
    };
}
exports.distributionPaymentsQuery = distributionPaymentsQuery;
//# sourceMappingURL=distributions.js.map